"use strict";

exports.__esModule = true;
exports.default = void 0;

var _media = _interopRequireDefault(require("./media"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "object",
  "properties": {
    "sectionType": {
      "enum": ["text"]
    },
    "media": _media.default,
    "leadtext": {
      "type": "localizedString"
    },
    "bodytext": {
      "type": "localizedString"
    },
    "links": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "title": {
            "type": "string"
          },
          "url": {
            "type": "string"
          }
        }
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;